"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Chrome storage-backed {@link AsyncMap}. */
class ChromeStorageAsyncMap {
    constructor(storage) {
        this.storage = storage;
    }
    async has(key) {
        const value = await this.get(key);
        return !!value;
    }
    async get(key) {
        var _a;
        const subset = await this.storage.get(key);
        return (_a = subset === null || subset === void 0 ? void 0 : subset[key]) !== null && _a !== void 0 ? _a : undefined;
    }
    async entries() {
        return await this.storage.get(null);
    }
    async set(key, value) {
        await this.storage.set({ [key]: value });
    }
}
exports.default = ChromeStorageAsyncMap;
//# sourceMappingURL=chrome-storage-async-map.js.map